import React from 'react';
import { LayoutDashboard, Users, FileText, ScrollText, Settings, Plug } from 'lucide-react';
import AppShell from './AppShell';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
  { label: 'Users', path: '/admin/users', icon: Users },
  { label: 'Exams', path: '/admin/exams', icon: FileText },
  { label: 'Logs', path: '/admin/logs', icon: ScrollText },
  { label: 'Settings', path: '/admin/settings', icon: Settings },
  { label: '3rd Party', path: '/admin/third-party', icon: Plug },
];

const AdminLayout = () => (
  <AppShell
    variant="sidebar"
    chromeTone="dark"
    contentTone="light"
    navItems={NAV_ITEMS}
    roleLabel="ADMIN"
    headerTitle="Admin Panel"
  />
);

export default AdminLayout;
